/**
 * Whether a recipient name carries an Austrian legal-form marker, i.e. the
 * recipient is evidently an entrepreneur or an association: GmbH, AG, KG,
 * OG, e.U., FlexKapG, Ges.m.b.H., GesmbH, Verein, Stiftung.
 *
 * <p>Used for § 11 Abs 1 Z 2 UStG: above EUR 10.000 gross an invoice needs
 * the buyer's UID when the buyer is an entrepreneur. The backend rule
 * mirrors this list — keep the two in step.
 *
 * <p>A marker counts only as a whole word (`AG` in "Hagen" or "Lager" does
 * not), compared case-insensitively. Exactly the backend's
 * `LegalFormMarker` list — nothing more, nothing tolerated.
 */
export const LEGAL_FORM_MARKERS = [
  'GmbH',
  'Ges.m.b.H.',
  'GesmbH',
  'Gesellschaft m.b.H.',
  'Gesellschaft mit beschränkter Haftung',
  'AG',
  'KG',
  'OG',
  'OHG',
  'KEG',
  'e.U.',
  'FlexKapG',
  'eGen',
  'Genossenschaft',
  'SE',
  'Verein',
  'Stiftung',
  'Privatstiftung',
  's.r.o.',
  'Kft.',
  'd.o.o.',
  'Ltd.',
  'S.A.',
] as const

const escape = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

const LEGAL_FORM_RE = new RegExp(
  `(?<![\\p{L}\\p{N}])(?:${LEGAL_FORM_MARKERS.map(escape).join('|')})(?![\\p{L}\\p{N}])`,
  'iu',
)

export function nameCarriesLegalForm(name: string | null | undefined): boolean {
  return !!name && LEGAL_FORM_RE.test(name)
}
